import React, { memo, useCallback } from 'react';
import { Wrench } from 'lucide-react';

const DEFAULT_MESSAGE =
  'Ведутся технические работы. Игра временно недоступна — зайдите через некоторое время.';

/**
 * Полноэкранная заглушка при включённом режиме техработ (после входа в аккаунт).
 * @param {{ message: string, retryAfterMinutes: number | null, username?: string | null, onLogout: () => void }} props
 */
function MaintenanceLockScreenInner({ message, retryAfterMinutes, username, onLogout }) {
  const text = String(message || '').trim() || DEFAULT_MESSAGE;
  const onClickLogout = useCallback(() => {
    onLogout?.();
  }, [onLogout]);

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center gap-6 bg-[#050a10] px-4 py-[max(1rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))] text-center"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="maintenance-title"
      aria-describedby="maintenance-desc"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(6,182,212,0.12)_0%,_transparent_55%)]" />
      <div className="relative z-[1] flex max-w-lg flex-col items-center gap-4 rounded-2xl border border-cyan-500/30 bg-gradient-to-b from-[#0c1c2e]/95 to-[#060d14]/95 px-6 py-8 shadow-[0_0_60px_rgba(6,182,212,0.15)]">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-amber-400/35 bg-amber-950/40 text-amber-200">
          <Wrench className="h-8 w-8" aria-hidden />
        </div>
        <h1 id="maintenance-title" className="text-xl font-black tracking-tight text-white sm:text-2xl">
          Технические работы
        </h1>
        {username ? (
          <p className="text-sm font-medium text-cyan-200/90">
            Аккаунт: <span className="text-white">{username}</span>
          </p>
        ) : null}
        <p id="maintenance-desc" className="whitespace-pre-wrap text-sm leading-relaxed text-slate-300 sm:text-base">
          {text}
        </p>
        {retryAfterMinutes != null && Number(retryAfterMinutes) > 0 ? (
          <p className="text-sm font-semibold text-amber-200/95">
            Ориентировочно зайдите через ~{Number(retryAfterMinutes)}{' '}
            {pluralRuMinutes(Number(retryAfterMinutes))}.
          </p>
        ) : null}
        <button
          type="button"
          onClick={onClickLogout}
          className="lobby-focus mt-2 rounded-xl border border-white/20 bg-white/10 px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-white/15"
        >
          Выйти из аккаунта
        </button>
      </div>
    </div>
  );
}

function pluralRuMinutes(n) {
  const x = Math.abs(Math.floor(n)) % 100;
  const y = x % 10;
  if (x > 10 && x < 20) return 'минут';
  if (y > 1 && y < 5) return 'минуты';
  if (y === 1) return 'минуту';
  return 'минут';
}

export const MaintenanceLockScreen = memo(MaintenanceLockScreenInner);
